import { TabList, secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledVideosWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.secondary.main};
  border-radius: ${({ theme }) => theme.radius.big};
  padding: 4.6rem 1.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 10rem 4.6rem 8rem 4.6rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 10rem 21.4;
  }
`;

export const StyledVideosTitle = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.text.invert};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 2.4rem;
  margin-bottom: 2.5rem;
  text-align: center;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  padding-inline: 1.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
    padding-inline: 0;
  }
`;

export const StyledVideosSubtitle = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.text.invert};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-bottom: 4.7rem;
  text-align: center;
  padding-inline: 1.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding-inline: 0;
  }
`;

export const StyledTabHeading = styled.span<{ tabWidth?: number }>`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  line-height: 1.6rem;
  color: ${secondaryColors.grey[200]};
  width: ${({ tabWidth }) => (tabWidth ? `${tabWidth + 30}px` : 'auto')};
  text-align: center;

  &:hover {
    background-color: ${secondaryColors.grey[900]};
  }

  &[data-state='active'] {
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
    color: ${secondaryColors.grey[200]};
  }
`;

export const StyledTabList = styled(TabList)`
  cursor: pointer;
  margin-bottom: 4.6rem;
  justify-content: center;
  align-items: center;
  display: none;

  span[role='tab'] {
    height: 4.8rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: flex;
  }
`;

export const StyledCarousel = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
`;

export const StyledCarouselContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-shrink: 0;
  transition: translate 0.6s ease-in-out;
`;

export const StyledIFrame = styled.iframe`
  border: none;
  width: 100%;
  aspect-ratio: 16 / 9;
  transition: translate 0.6s ease-in-out;
`;

export const StyledImage = styled.img`
  border: none;
  width: 100%;
  aspect-ratio: 16 / 9;
  transition: translate 0.6s ease-in-out;
`;

export const StyledDescription = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.text.invert};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-top: 2rem;
  padding-inline: 1.8rem;
  transition: translate 0.6s ease-in-out;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding-inline: 2.6rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding-inline: 5rem;
  }
`;

export const StyledFormSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  width: 100%;
  margin-bottom: 3rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: none;
  }
`;

export const StyledFormSelect = styled.div`
  > div {
    margin-left: auto;
    margin-right: auto;
    width: 24.1rem;
    text-align: start;
    > button {
      border: 0.1rem solid ${({ theme }) => theme.colors.secondary.lighter};
    }
  }
`;
